import React, { useState } from 'react';
import cx from 'classnames';
import { FixedSizeList as List } from 'react-window';
// BluePrint JS
import { Menu, MenuItem } from '@blueprintjs/core';
import { Popover, TextInput } from '../..';
import { chevronIcon } from '../functions/icons';
export const InlineDropDown = ({ searchItems, updateSelection, selectedItem, isIconOnly = false, onInteractionCB = null, mode = 'light', openPosition = 'bottom-left', selectedTitle = '', width = 180, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const canSearch = searchItems.length >= 20;
    const setSearchOnChange = (e) => setSearchValue(e.target.value);
    // Make sure it's a case-insensitive search
    const filteredItems = searchItems.filter(({ label }) => {
        return typeof label !== 'undefined' && label.toLowerCase().includes(searchValue.toLowerCase());
    });
    const row = ({ index, style }) => {
        const item = filteredItems[index];
        const isSelected = selectedItem.key === item.key;
        const { key, label, icon } = item;
        const selectItemOnKeyPress = (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                updateSelection(item);
                setIsOpen(false);
            }
        };
        return (React.createElement(MenuItem, { className: cx('dropdown_item', {
                'dropdown_item--selected': isSelected,
                'dropdown_item--empty': key === 'NullValue',
                'dropdown_item--text': icon === undefined,
            }), key: `dropdown-item-${key}`, text: label, icon: icon, shouldDismissPopover: true, onClick: () => updateSelection(item), onKeyPress: selectItemOnKeyPress, tabIndex: 0, style: style }));
    };
    const createDropdownMenu = () => {
        const itemCount = filteredItems.length;
        const listHeight = itemCount < 10 ? itemCount * 32 : 300;
        return (React.createElement(Menu, null,
            React.createElement(List, { height: listHeight, width: mode === 'dark' ? 60 : width, itemSize: 32, itemCount: itemCount }, row)));
    };
    const onInteraction = (nextState) => {
        if (!isOpen) {
            setIsOpen(true);
        }
        if (onInteractionCB) {
            onInteractionCB(nextState);
        }
    };
    return (React.createElement(Popover, { popoverClassName: "inline-dropdown_popover", position: openPosition, transitionDuration: 0, autoFocus: false, isOpen: isOpen, canEscapeKeyClose: false, onClose: () => setIsOpen(false), onInteraction: onInteraction },
        React.createElement("button", { className: cx('inline-dropdown_button', {
                'inline-dropdown_button--open': isOpen,
                'inline-dropdown_button--icon': isIconOnly,
                'inline-dropdown_button--darkmode': mode === 'dark',
                'inline-dropdown_button--lightmode': mode === 'light',
            }) },
            selectedItem.icon && selectedItem.icon,
            selectedTitle !== '' ? (React.createElement("span", { className: "inline-dropdown_button--title" }, selectedTitle)) : null,
            React.createElement("span", { className: "inline-dropdown_button--item" }, selectedItem.label),
            mode === 'light' ? (React.createElement("div", { className: "inline-dropdown_button--chevron" }, chevronIcon)) : (React.createElement("div", { className: "inline-dropdown_button--chevron" }))),
        React.createElement("div", { className: "inline-dropdown_content" },
            canSearch && (React.createElement("div", { className: "inline-dropdown_search-container" },
                React.createElement(TextInput, { className: "inline-dropdown_search-input", value: searchValue, onChange: setSearchOnChange, placeholder: 'Filter', autoFocus: true }))),
            createDropdownMenu())));
};
//# sourceMappingURL=InlineDropdown.js.map